import * as types from '../constants/actionTypes';

export function loadBookmarks() {
  return function (dispatch) {
    return dispatch({
      type: types.BOOKMARKS_LOADING,
    });
  };
}

export function loadUsers() {
  return function (dispatch) {
    return dispatch({
      type: types.USERS_LOADING,
    });
  };
}

export function saveBookmark(bookmark) {
  return function (dispatch) {
    return dispatch({
      type: types.SAVE_BOOKMARK_REQUEST,
      bookmark: bookmark,
    });
  };
}

export function deleteBookmark(bookmark) {
  return function (dispatch) {
    return dispatch({
      type: types.DELETE_BOOKMARK_REQUEST,
      bookmark: bookmark,
    });
  };
}
